export default "__VITE_ASSET__DPw0QjEU__"